export default "__VITE_ASSET__BTTPCTH$__"